import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";

function ResetPassword() {
  const { encoded } = useParams(); // Get encoded string from route
  const [formData, setFormData] = useState({ password: "", confirmPassword: "" });
  const [distributorDetails, setDistributorDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Decode base64
  useEffect(() => {
    try {
      const decoded = atob(encoded); // Decode base64
      const [email, id, name] = decoded.split("/");
  
      console.log("Decoded data:", { email, id, name }); // ✅ Log the decoded values
  
      setDistributorDetails({ email, id, name });
    } catch (error) {
      console.error("Decoding error:", error);
      Swal.fire("Invalid Link", "The password reset link is invalid.", "error");
    }
  }, [encoded]);
  

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
  
    if (formData.password !== formData.confirmPassword) {
      return Swal.fire("Error", "Passwords do not match.", "error");
    }
  
    try {
      setIsSubmitting(true);
  
      const payload = {
        id: distributorDetails.id,
        password: formData.password,
        email: distributorDetails.email,
      };
  
      console.log("Sending password reset data:", payload); // ✅ Log sent data
  
      const response = await axios.post(`${baseurl}setDistributorPassword`, payload);

console.log("response", response);

if (response.status === 200 && response.data.message === "Password updated successfully") {
  Swal.fire({
    title: "Success",
    text: "Password has been set!",
    icon: "success",
    confirmButtonText: "OK"
  }).then(() => {
    window.location.href = "/distributor-login";
  });
} else {
  Swal.fire("Failed", response.data.message || "Something went wrong.", "error");
}

    } catch (error) {
      console.error("Password reset error:", error);
      Swal.fire("Error", "An error occurred while resetting password.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <>
       
      <div className="container mt-5">
        <div className="col-md-6 offset-md-3 bg-white p-4 border rounded">
          <h3 className="mb-4 text-center">Set Your Password</h3>

          {distributorDetails ? (
            <form onSubmit={handleResetPassword}>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                {isSubmitting ? "Saving..." : "Set Password"}
              </button>
            </form>
          ) : (
            <div className="text-danger text-center">Invalid or expired link.</div>
          )}
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
